import { defineComponent as r, createBlock as a, openBlock as p, unref as l, mergeProps as m, withCtx as c, createElementVNode as o } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconPower",
  __name: "IconPower",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (i, e) => (p(), a(l(s), m(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        o("path", { d: "M11.25 3.5v9a.75.75 0 0 0 1.5 0v-9a.75.75 0 0 0-1.5 0" }, null, -1),
        o("path", { d: "M9.281 5.777a.75.75 0 1 0-.562-1.39A8.753 8.753 0 0 0 12 21.25a8.75 8.75 0 0 0 3.281-16.864.75.75 0 0 0-.562 1.39A7.253 7.253 0 0 1 12 19.75 7.25 7.25 0 0 1 9.281 5.777" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
